<template>
	<b-form @submit.prevent="submit">
		<b-input-group>
			<b-form-input
				ref="queryInput"
				v-model="query"
				list="geocoderesult"
				:placeholder="$t('geocoder.input-placeholder')"
				autocomplete="off"
				type="text"
				@keydown="toggleResultList"
			/>
			<template #append>
				<b-button primary type="submit">
					<b-icon-search />
				</b-button>
			</template>
		</b-input-group>
		<b-list-group v-if="showResultList && results.length" v-model="results" class="geocoder-results">
			<b-list-group-item
				v-for="(result, index) in results"
				:key="result.place_id"
				:data-index="index"
				class="result-item"
				:class="{ hover: result.active }"
				@click="selectLocation(index)"
			>
				{{ result.display_name }}
			</b-list-group-item>
		</b-list-group>
	</b-form>
</template>

<script>
const GEOCODER_URL = 'https://nominatim.openstreetmap.org/search';
export default {
	name: 'Geocoder',
	data() {
		return {
			query: '',
			results: [],
			showResultList: true,
		};
	},
	methods: {
		selectLocation(index) {
			const location = this.results[index];
			this.query = location.display_name;
			this.showResultList = false;
			this.$emit('locationSelected', location);
		},
		toggleResultList(event) {
			if (event.keyCode === 27) this.showResultList = false;
			const prevIndex = this.results.findIndex((r) => r.active);

			if (prevIndex !== -1 && event.keyCode === 13) {
				this.selectLocation(prevIndex);
				event.preventDefault();
			}

			if (!this.results.length || (event.keyCode !== 40 && event.keyCode !== 38)) return;
			this.showResultList = true;

			let currIndex = prevIndex;
			if (event.keyCode === 40) {
				// down arrow
				currIndex += 1;
				if (currIndex > this.results.length - 1) currIndex = -1;
			} else if (event.keyCode === 38) {
				// up arrow
				currIndex -= 1;
			}
			if (prevIndex > -1) this.results[prevIndex].active = false;
			if (currIndex > -1) this.results[currIndex].active = true;
			// force rerendering of the result list
			this.$forceUpdate();
			event.preventDefault();
		},
		async submit() {
			const latlon = /\s*(\d{1,2}\.\d+)\s*,\s*(\d{1,2}\.\d+)\s*$/i.exec(this.query);
			if (latlon && latlon.length === 3) {
				this.showResultList = false;
				this.$emit('locationSelected', { lat: latlon[1], lon: latlon[2] });
				return;
			}
			const request = await fetch(`${GEOCODER_URL}/${this.query}?format=json`);
			this.results = await request.json();
			this.showResultList = true;
			if (!this.results.length) return;
			this.results.sort((a, b) => a.importance > b.importance);
		},
	},
};
</script>

